import styled from 'styled-components';

export const EmailResentMessage = styled.span`
  display: flex;
  justify-content: center;
  align-items: center;
`;
